<app-title-bar rootBreadCrumbs="['i18n.core.navigation.reports']" titleText="i18n.domain.reports.tags.title"></app-title-bar>
<div class="row">
  <app-tags-form class="col" [form]="filterForm" (searchDTOChanged)="searchReports()"></app-tags-form>
</div>
@if (selectedClient) {
  <ejs-grid #grid
            class="grid-with-footer"
            width="100%"
            rowHeight="38"
            [allowPaging]="true"
            [pageSettings]="pageSettings"
            [dataSource]="data">
    <e-columns>
      <e-column field="firstName"
                headerText="{{'i18n.shared.fields.firstname' | translate}}"
                clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="lastName"
                headerText="{{'i18n.shared.fields.lastname' | translate}}"
                clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="company"
                headerText="{{'i18n.domain.reports.tags.grid.company' | translate}}"
                clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="parkerTag.operationalControlPlate"
                headerText="{{'i18n.domain.reports.tags.grid.controlPlate' | translate}}"
                clipMode="EllipsisWithTooltip">
        <ng-template #template let-data>
          <span class="text-uppercase">{{data.parkerTag.operationalControlPlate}}</span>
        </ng-template>
      </e-column>
      <e-column field="parkerTag.identificationCode"
                headerText="{{'i18n.domain.reports.tags.grid.identificationCode' | translate}}"
                clipMode="EllipsisWithTooltip">
      </e-column>
    </e-columns>
  </ejs-grid>
  <app-reports-footer (saveClicked)="saveReport($event)"></app-reports-footer>
}

